export const MORNINGSTAR_STYLE_BOX_CATEGORY_KEY = 'base' as const;
export const MORNINGSTAR_STYLE_BOX_COMPONENT_KEY = 'morningstarStyleBox' as const;
